import { useContext } from 'react';
import { ToastContext } from '../context/ToastContext';

/**
 * Custom hook to access the showToast function from ToastContext.
 * Allows components to trigger global toast notifications.
 * @returns {{ showToast: (message: string, type?: 'success' | 'error' | 'info', duration?: number) => void }}
 */
export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};
